import imagePregnant from "assets/img/pregnant.png";
import imageNotPregnant from "assets/img/not-pregnant.png";
import { Trans } from "react-i18next";
import i18next from "i18next";

export default ({ fields, setFields, invalidFields, state, actions }) => {
    let borderStyle = invalidFields && invalidFields.pregnant ? '2px solid red' : 'none';
  return (
    <>
      <fieldset>
        <div role="group" className={`standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset pregnant-div ${!(state && state.isTravelAid2) ? "" : "travelAidPregDiv"} ${fields.gender == "M" ? "hide" : ""}`}>
          <div className={`${ !(state && state.isTravelAid2) ? "standby-col standby-col-shrink standby-form-legend" : "pregnant-label" }`}>
            <legend>
              {!state.isTravelAid2 ? 
                <h2
                  className={`${ !(state && state.isTravelAid2) ? "standby-form-legend-text" : "standby-form-legend-text1"}`}>
                  <span>
                    <Trans i18nKey="findcareoption.Start.Pregnancystatus">
                      {" "}
                      Are you currently pregnant?
                    </Trans>
                  </span>
                </h2>
              :
                <h5
                  className={`${ !(state && state.isTravelAid2) ? "standby-form-legend-text" : "standby-form-legend-text1" }`}>
                  <span>
                    <Trans i18nKey="findcareoption.Start.Pregnancystatus">
                      {" "}
                      Are you currently pregnant?
                    </Trans>
                  </span>
                </h5>
              }
            </legend>
          </div>
          <div className={`${ !(state && state.isTravelAid2) ? "standby-col standby-form-inline-fields pregnancy-select-container" : "pregnant-radio-container"}`}>
            <label htmlFor="rbPregnant" id="lblPregnant" className={`${ !(state && state.isTravelAid2) ? "standby-form-field-radio is-selected" : "pregnant-yes-label"}`} style={{border: borderStyle}}>
              <input
                type="radio"
                name="pregnancy-radio"
                id="rbPregnant"
                aria-label={i18next.t("findcareoption.Start.Pregnancystatus")+ " " + i18next.t("findcareoption.Yes")}
                value="1"
                className={`${
                  !(state && state.isTravelAid2)
                    ? "standby-form-field-radio-input"
                    : "radio-pregnant-yes"
                }`}
                checked={fields.pregnant === true}
                onClick={() => {
                  fields.gender === "F" && setFields({ pregnant: true });
                  if (!document.getElementById("rbPregnant").checked 
                      && !document.getElementById("rbNoPregnant").checked)
                  {
                      document.getElementById('lblPregnant').style.border = 'borderStyle';
                      document.getElementById('lblNoPregnant').style.border = 'borderStyle';
                      document.getElementById('errorIsPregnant').style.display = 'block';
                  }
                  else
                  {
                      invalidFields.pregnant = '';
                      document.getElementById('lblPregnant').style.border = '';
                      document.getElementById('lblNoPregnant').style.border = '';
                      document.getElementById('errorIsPregnant').style.display = 'none';
                  }
                }
              }
                disabled={fields.gender !== "F"}
                onChange={() => {}}
              />
              {/* <label></label> */}
              {state && state.isTravelAid2 ? "" : <img role="img" src={imagePregnant} />}
              <span className={`${!(state && state.isTravelAid2) ? "span-color-override" : "span-pregnant-yes"}`}>
                <Trans i18nKey="findcareoption.Yes"> Yes</Trans>
              </span>
            </label>
            <label htmlFor="rbNoPregnant" id="lblNoPregnant" className={`${ !(state && state.isTravelAid2) ? "standby-form-field-radio is-selected" : "pregnant-no-label" }`} style={{border: borderStyle}}>
              {/* <label value={fields.pregnant === false}></label> */}
              <input
                type="radio"
                name="pregnancy-radio"
                id="rbNoPregnant"
                aria-label={i18next.t("findcareoption.Start.Pregnancystatus")+ " " + i18next.t("findcareoption.No")}
                value="0"
                className={`${
                  !(state && state.isTravelAid2)
                    ? "standby-form-field-radio-input"
                    : "radio-pregnant-no"
                }`}
                checked={fields.pregnant === false}
                onClick={() => 
                  {
                    setFields({ pregnant: false });
                    if (!document.getElementById("rbPregnant").checked 
                        && !document.getElementById("rbNoPregnant").checked)
                    {
                        document.getElementById('lblPregnant').style.border = 'borderStyle';
                        document.getElementById('lblNoPregnant').style.border = 'borderStyle';
                        document.getElementById('errorIsPregnant').style.display = 'block';
                    }
                    else
                    {
                        invalidFields.pregnant = '';
                        document.getElementById('lblPregnant').style.border = '';
                        document.getElementById('lblNoPregnant').style.border = '';
                        document.getElementById('errorIsPregnant').style.display = 'none';
                    }
                  }
                }
                onChange={() => {}}
              />
              {/* <label></label> */}
              {state.isTravelAid2 ? "" : <img role="img" src={imageNotPregnant} />}
              <span className={`${!(state && state.isTravelAid2) ? "span-color-override" : "span-pregnant-no"}`}>
                <Trans i18nKey="findcareoption.No"> No</Trans>
              </span>
            </label>
          </div>
        </div>
      </fieldset>
      <div id="errorIsPregnant" className="errormessage-phone"
         style={{ display: invalidFields.pregnant 
         ? "block" 
         : "none" 
         }}>
          {i18next.t("findcareoption.Start.errorMessages.errorPregnancystatus")}
      </div>
    </>
)};
